$(document).ready(function () {
  $("body").removeClass("preload");
  $(".main-slider").owlCarousel({
    items: 1,
    autoHeight: false,
    loop: true,
    autoplay: true,
    autoplaySpeed: 1500,
    animateOut: "fadeOut",
    animateIn: "fadeIn",
    dots: true,
  });
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    //>=, not <=
    if (scroll >= 500) {
      //clearHeader, not clearheader - caps H
      $("header").addClass("small");
    } else {
      $("header").removeClass("small");
    }
  });
  $(".readmore").readmore({
    moreLink:
      '<div class="col-12 col-lg-9 text-center mt-5"><a href="#" class="btn btn-light">Lire plus</a></div>',
    lessLink:
      '<div class="col-12 col-lg-9 text-center mt-5"><a href="#" class="btn btn-light">Fermer</a></div>',
    collapsedHeight: 300,
  });

  $(".burger-menu").on("click", function () {
    $(this).children(".hamburger").toggleClass("is-active");
    $("nav.menu").toggleClass("open");
  });

  //scrolldown

  // fin scrolldown

  var COOKIE_NOTICE = "cookie-notice";

  $gonotice = $.cookie(COOKIE_NOTICE);
  if ($gonotice == null) {
    $("body").append(
      '<div id="cookie_notice"><h3>Cookies</h3><p>Nous utilisons des cookies pour vous garantir la meilleure expérience sur notre site web. Si vous continuez à utiliser ce site, nous supposerons que vous en êtes satisfait. <a href="/politique-de-cookies/">Politique de cookies</a></p><a href="#" class="btn btn-secondary btn-sm closecookie">J\'ai compris</a></div>'
    );
    $("#cookieConsentContainer").fadeIn();
  }
  $("#cookie_notice .closecookie").on("click", function (e) {
    e.preventDefault();
    $.cookie(COOKIE_NOTICE, "done", { path: "/", expires: 6 });
    $("#cookie_notice").fadeOut();
  });
});
